export default __webpack_public_path__ + "bfdd83358d89615b7b14799856fc74dd.png";